import { ActionTree } from "vuex";
import { MutationTypes } from "./mutations";
import { State } from "./index";
import { RootState, store } from "@/store";
import * as fb from "../../../firebase";
import firebase from "firebase";
import { ClassData } from "@/interfaces/contentStore";
import { ClassProgress, UserWatching } from "@/interfaces/videoPlayerStore";
import { AugmentedActionContext } from "./types";
import { Actions } from "./interfaces";
import { ActionTypes as Auth } from "../auth";

// Actions
// place the action definition as a string
// ==> { setX = "MODULE__SET_ X" }
export enum ActionTypes {
	addUserClassProgress = "ADD_USER_CLASS_PROGRESS",
	selectCurrentVideo = "SELECT_CURRENT_VIDEO",
	addUserWatchedVideo = "USER_WATCHED_VIDEO",
	setVideoComplete = "VIDEO_COMPLETE",
	fetchCurrentViewingUsers = "SEE_WHO_ELSE",
	clearWatchList = "CLEAR_VIEWERS",
	fetchWatchHistory = "VIDEOS_WATCHED",
	fetchEntireWatchHistory = "ENTIRE_WATCH_HISTORY",
	updateVideoWatchMilestone = "MILESTONE_VIDEO_REACHED",
	updateDailyWatchMilestone = "MILESTONE_DAILY_REACHED",
	updateWeeklyWatchMilestone = "MILESTONE_WEEKLY_REACHED",
	reset = "RESET",
	fetchClassProgressData = "FETCH_CLASS_PROGRES_DATA"
}

// [C.3] declare actions
// [ActionTypes.setX]({ commit }, payload) {
//   commit(MutationTypes.X, payload);
// },
export const actions: ActionTree<State, RootState> & Actions = {
	[ActionTypes.selectCurrentVideo]({ commit }, payload: ClassData) {
		commit(MutationTypes.SET_CURRENT_VIDEO, payload);
	},

	[ActionTypes.addUserClassProgress](
		{ commit }: AugmentedActionContext,
		payload: firebase.firestore.DocumentData
	) {
		console.log("THIS HAS BEEN CALLED");
		fb.users
			.doc(payload.userID)
			.collection("classProgress")
			.doc(payload.classID)
			.set({
				classID: payload.classID,
				currentTime: payload.currentTime,
				startTime: firebase.firestore.FieldValue.serverTimestamp(),
				currentlyViewing: payload.currentlyViewing,
				user: fb.users.doc(payload.userID),
				isFinished: payload.isFinished
			});
	},

	async [ActionTypes.addUserWatchedVideo](
		{ commit }: AugmentedActionContext,
		payload: any
	) {
		const docRef = await fb.users
			.doc(payload.userID)
			.collection("classWatchHistory")
			.add({
				class: fb.db.doc("/classes/" + payload.classID),
				startTime: firebase.firestore.FieldValue.serverTimestamp(),
				categoryName: payload.video.categoryName,
				trainerImg: payload.video.trainerData.imgURL,
				trainerName: payload.video.trainerData.name,
				className: payload.video.name,
				startingDate: payload.video.date,
			});

		// console.log(docRef);
		const docData = await docRef?.get();

		commit(MutationTypes.SET_RECORD, { ...docData?.data(), id: docData?.id });
	},

	async [ActionTypes.setVideoComplete](
		{ commit }: AugmentedActionContext,
		payload: firebase.firestore.DocumentData
	) {
		await fb.users
			.doc(payload.userID)
			.collection("classProgress")
			.doc(payload.classID)
			.update({
				isFinished: payload.isFinished,
				currentTime: payload.currentTime,
				currentlyViewing: payload.currentlyViewing,
				calories: payload.calories,
				heartRate: payload.heartRate,
			});
		await store.dispatch(ActionTypes.fetchWatchHistory, {userID: payload.userID})
		// console.log();
		const sendEmail = firebase.functions().httpsCallable("sendEmail");
		const content = `Thank you for joining the class ${payload.classID}. <br /> This is your activity statistics in this class.<br/> duration: ${payload.duration} <br/> duration: ${payload.calories} <br/> duration: ${payload.heartRate}<br/><br/> Platform Studio Team`;
		sendEmail({ title: "Activity Summary", content });
	},

	async [ActionTypes.fetchClassProgressData](
		{ commit }: AugmentedActionContext,
		payload: any) {

		const classData = await fb.users.doc(payload.userID)
			.collection("classProgress")
			.doc(payload.classID)
			.get();
		
		if(classData.exists && !classData?.data()?.isFinished){
			return classData.data()
		} 

		return {currentTime: 0}

	},

	async [ActionTypes.fetchCurrentViewingUsers](
		{ commit }: AugmentedActionContext,
		payload: any
	) {
		let {users} = payload;
		users = users.filter( (user: any) => user.uid !== store.getters.userProfile.uid)
		commit(MutationTypes.SET_VIEWERS, users);
	},

	[ActionTypes.clearWatchList]({ commit }: AugmentedActionContext) {
		commit(MutationTypes.SET_VIEWERS, [] as UserWatching[]);
	},

	async [ActionTypes.fetchWatchHistory](
		{ commit }: AugmentedActionContext,
		payload: any
	) {
		fb.users
			.doc(payload.userID)
			.collection("classProgress")
			.get()
			.then((querySnapshot: firebase.firestore.QuerySnapshot) => {
				let watchedClasses = [] as ClassProgress[];

				watchedClasses = querySnapshot.docs.map(
					(classDoc: firebase.firestore.DocumentSnapshot) => {
						const classDat = classDoc?.data();
						if (classDat) {
							const returnValue: ClassProgress = {
								classID: classDat.classID ? classDat.classID : classDoc.id,
								currentTime: classDat.currentTime ? classDat.currentTime : 0,
								currentlyViewing: classDat.currentlyViewing,
								isFinished: classDat.isFinished,
								startTime: classDat.startTime,
							};
							return returnValue;
						}
						return {} as ClassProgress;
					}
				);

				// console.log("WATCHED CLASSES", watchedClasses);
				commit(MutationTypes.SET_USER_CLASS_PROGRESS, watchedClasses);
			})
			.catch((err) => console.log("ERROR", err));
	},

	async [ActionTypes.fetchEntireWatchHistory](
		{ commit }: AugmentedActionContext,
		payload: any
	) {
		// If necessary
		// const user = await fb.users.doc(payload).get();
		// const userData = user.data();
		// console.log(userData);

		const watchHistoryCollection = await fb.users
			.doc(payload)
			.collection("classWatchHistory")
			.orderBy("startTime", "desc")
			.get();

		const watchHistory = [];
		// console.log("Watch History docs", watchHistoryCollection)
		for (const video of watchHistoryCollection.docs) {
			// console.log("I'm here", video.data())
			watchHistory.push(video.data());
		}

		return watchHistory;
	},
	async [ActionTypes.updateVideoWatchMilestone]({ commit }, payload) {
		const addToVideoChallenge = firebase
			.functions()
			.httpsCallable("addToVideoChallenge");

		const response = await addToVideoChallenge({
			class: payload.classObject,
		});

		// console.log("YAY THAT EXECUTED", response);

		store.dispatch(Auth.userProfile, payload.userID);
	},

	async [ActionTypes.updateDailyWatchMilestone]({ commit }, payload) {
		// console.log("EXECUTING FUNCT DAILY")
		const addToDailyChallenge = firebase
			.functions()
			.httpsCallable("addToDailyChallenge");
		const addToWeeklyChallenge = firebase
			.functions()
			.httpsCallable("addToWeeklyChallenge");

		const [dailyResponse, response] = await Promise.allSettled([
			addToDailyChallenge({
				class: payload.class,
			}),
			addToWeeklyChallenge({
				class: payload.class,
			}),
		]);
		// const dailyResponse = await addToDailyChallenge({
		// 	class: payload.class
		// });
		// const response = await addToWeeklyChallenge({
		// 	class: payload.class
		// });

		// console.log("YAY THAT EXECUTED", dailyResponse, response);
		// console.log("THE OTHER DATA LOL", response);

		store.dispatch(Auth.userProfile, payload.userID);
	},

	async [ActionTypes.updateWeeklyWatchMilestone]({ commit }, payload) {
		console.log("EXECUTING WEEKLY");
		const func = firebase.functions().useEmulator("localhost", 5001)

		const addToWeeklyChallenge = fb.functions
			.httpsCallable("addToWeeklyChallenge")
			
			

		const response = await addToWeeklyChallenge({
			class: payload.class,
		});

		console.log("YAY THAT EXECUTED WEEKLY", response);

		store.dispatch(Auth.userProfile, payload.userID);
	},

	// RESET
	async [ActionTypes.reset]({ commit }) {
		commit(MutationTypes.reset);
	},
};
